const start = {
  slug: 'start',
  title: 'Welkom bij de EDUbox Mobiliteit!',
  body:
    'Ben je klaar om je eigen mobiliteitsplan uit te dokteren? Stap voor stap zal je moeten bepalen hoe de verschillende weggebruikers zich het best verplaatsen om te pendelen, winkelen, ontspannen en transporteren. Het doel? <strong>De mobiliteitsknoop ontwarren en iedereen mobiel maken!</strong>',
  controls: false,
  cameraPosition: [489.25, 98.93, 366.41],
  cameraRotation: [-0.78, 0.82, 0.62],
  backgroundImage: 'edubox_mobiliteit_cover.jpg',
  metrics: [],
  layers: ['base'],
};

const intro = {
  slug: 'intro',
  title: 'Het is vrijdagavond en 4,7 miljoen mensen stappen in hun auto.',
  body:
    'Deze pendelaars gaan van hun werk naar huis. Druk op de knoppen met + en - om meer of minder verplaatsingen te zien. Bekijk onderaan het scherm de impact op de eerste parameters. Ga vervolgens naar 100% en klik op volgende.',
  goal: 4700000,
  goalText: '4,7 miljoen verplaatsingen',
  controls: true,
  controlsPendelen: true,
  controlsAuto: true,
  cameraPosition: [381.23157530815513, 37.81549448930892, 305.31621775521654],
  cameraRotation: [-0.645400718594391, 0.8839307162855453, 0.5272481433339529],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming'],
  hint: 'Zorg dat je aan 100% van de verplaatsingen komt.',
};

const fietsVoetgangers = {
  slug: 'fietsVoetgangers',
  title: 'Mensen gaan ook per fiets of te voet naar hun werk.',
  body:
    'Verdeel alle verplaatsingen nu over de 3 vervoermiddelen. De som moet altijd 100% zijn. Experimenteer een beetje met de combinaties, maar kies uiteindelijk een verdeling die jij goed vindt. Hou opnieuw de parameters onderaan het scherm in de gaten.',
  goal: 4700000,
  goalText: '4,7 miljoen verplaatsingen',
  controls: true,
  controlsPendelen: true,
  controlsAuto: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [237.43033074382348, 40.30569672173516, 328.666815056608],
  cameraRotation: [-0.5227310018925713, -0.6260437933433969, -0.32560087150317363],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid'],
};

const openbaarVervoer = {
  slug: 'openbaarVervoer',
  title: 'Sommige pendelaars nemen het openbaar vervoer.',
  body:
    'Sommige pendelaars nemen het openbaar vervoer.<br>Er is ook openbaar vervoer (OV) aanwezig in de stad. Een deel van de mensen neemt de bus, trein of tram. Kies nu hoeveel procent van de verplaatsingen je hierop inzet.',
  goal: 4700000,
  goalText: '4,7 miljoen verplaatsingen',
  controls: true,
  controlsPendelen: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [369.1634922945258, 138.32855150743222, 310.12400938969733],
  cameraRotation: [-0.8587471000216486, 0.4252691881967879, 0.44589803044461945],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid', 'leefbaarheid', 'economie'],
};

const winkelen = {
  slug: 'winkelen',
  title: 'Naast de pendelaars willen 3,8 miljoen mensen gaan winkelen.',
  body:
    'Verdeel ook de verplaatsingen van de shoppers over de verschillende vervoermiddelen. Misschien zie je deze verdeling anders? De som in elke kolom moet altijd 100% zijn. Je ziet de impact van jouw beslissingen direct in de parameters.',
  goal: 8500000,
  goalText: '8,5 miljoen verplaatsingen',
  controls: true,
  controlsHeader: true,
  controlsPendelen: true,
  controlsWinkelen: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [560.6529710260968, 53.09900049136678, 389.18017837701325],
  cameraRotation: [-0.2645715140664622, 0.9748986946315688, 0.2205792492472329],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid', 'leefbaarheid', 'economie', 'gezondheid', 'bereikbaarheid'],
};

const vrijeTijd = {
  slug: 'vrijeTijd',
  title: '4,9 miljoen anderen mensen zijn op weg naar de sportclub, hun familie of de film.',
  body: 'Nog meer volk op de baan! Mensen verplaatsen zich ook in hun vrije tijd. Verdeel nu deze verplaatsingen onder de vervoermiddelen.',
  goal: 13400000,
  goalText: '13,4 miljoen verplaatsingen',
  controls: true,
  controlsHeader: true,
  controlsPendelen: true,
  controlsWinkelen: true,
  controlsVrijeTijd: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [-38.62036327057939, 36.33594022222191, 316.69881581214736],
  cameraRotation: [-0.28384499602401714, -1.0922572279570424, -0.2533864977089945],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid', 'leefbaarheid', 'economie', 'gezondheid', 'bereikbaarheid', 'klimaat'],
};

const transport = {
  slug: 'transport',
  title: 'Vrachtvervoer neemt ook plaats in op de weg. ',
  body:
    'Alles wat we in de winkel vinden of thuis laten leveren, moet worden vervoerd. Hiervoor zijn andere vervoersmiddelen beschikbaar: trein, boot, bakfiets en vrachtwagens. Verdeel ook deze verplaatsingen. <strong>Maak uiteindelijk iedereen mobiel!</strong>',
  goal: 15500000,
  goalText: '15,5 miljoen verplaatsingen',
  controls: true,
  controlsHeader: true,
  controlsPendelen: true,
  controlsWinkelen: true,
  controlsVrijeTijd: true,
  controlsTransport: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [77.64352730368145, 221.35095042545714, 336.40619459496065],
  cameraRotation: [-0.8938615813384486, -0.34831607469962156, -0.4016426602522801],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid', 'leefbaarheid', 'economie', 'gezondheid', 'bereikbaarheid', 'klimaat'],
};

const sandbox = {
  slug: 'sandbox',
  title: 'Is iedereen mobiel?',
  body:
    'Het verkeer is een complex zaak. Je hebt nu je keuzes gemaakt. Onderaan het scherm zie je de scores voor alle parameters. Of misschien wil je toch nog wat balkjes aanpassen? Let er wel op dat de som in elke kolom altijd 100% moet zijn! Ga verder als je klaar bent. ',
  goal: 15500000,
  goalText: '15,5 miljoen verplaatsingen',
  controls: true,
  controlsHeader: true,
  controlsPendelen: true,
  controlsWinkelen: true,
  controlsVrijeTijd: true,
  controlsTransport: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
  cameraPosition: [243.04027789018377, 234.6745693429895, 376.49084740702153],
  cameraRotation: [-0.9508358660042415, -0.0050254356198086965, -0.007039765014266583],
  layers: ['base'],
  metrics: ['luchtkwaliteit', 'doorstroming', 'veiligheid', 'leefbaarheid', 'economie', 'gezondheid', 'bereikbaarheid', 'klimaat'],
};

const einde = {
  slug: 'einde',
  title: 'Je resultaten!',
  body:
    'Hieronder zie je de resultaten van je simulatie. Je ziet zowel je verdeling van vervoermiddelen als je score op de 8 parameters (op 100%). Klik op de tekst in het kader en kopieer de resultaten. Mail ze naar jezelf en naar het mailadres dat de leerkracht je opgeeft. Je hebt ze straks nog nodig.',
  cameraPosition: [243.04027789018377, 234.6745693429895, 376.49084740702153],
  cameraRotation: [-0.9508358660042415, -0.0050254356198086965, -0.007039765014266583],
  layers: ['base'],
  metrics: [],
  export: true,
  goal: 15500000,
  controls: true,
  controlsHeader: true,
  controlsPendelen: true,
  controlsWinkelen: true,
  controlsVrijeTijd: true,
  controlsTransport: true,
  controlsAuto: true,
  controlsOV: true,
  controlsFiets: true,
  controlsVoetganger: true,
};

const sequence = {
  name: 'Edubox mobiliteit: keuzes voor een duurzame ontknoping',
  db: 'edubox_mobiliteit',
  scenes: [start, intro, fietsVoetgangers, openbaarVervoer, winkelen, vrijeTijd, transport, sandbox, einde],
  layerMap: {
    bereikbaarheid: {
      '0': ['bereikbaarheid_1'],
      '1': ['bereikbaarheid_1', 'bereikbaarheid_2'],
      '2': ['bereikbaarheid_1', 'bereikbaarheid_2', 'bereikbaarheid_3'],
      '3': ['bereikbaarheid_1', 'bereikbaarheid_2', 'bereikbaarheid_3', 'bereikbaarheid_4'],
      '4': ['bereikbaarheid_1', 'bereikbaarheid_2', 'bereikbaarheid_3', 'bereikbaarheid_4', 'bereikbaarheid_5'],
    },
    veiligheid: {
      '0': ['veiligheid_1', 'veiligheid_2', 'veiligheid_3', 'veiligheid_4', 'veiligheid_5'],
      '1': ['veiligheid_1', 'veiligheid_2', 'veiligheid_3', 'veiligheid_4'],
      '2': ['veiligheid_1', 'veiligheid_2', 'veiligheid_3'],
      '3': ['veiligheid_1', 'veiligheid_2'],
      '4': ['veiligheid_1'],
      '5': [],
    },
    leefbaarheid: {
      '0': [],
      '1': ['leefbaarheid_1'],
      '2': ['leefbaarheid_1', 'leefbaarheid_2'],
      '3': ['leefbaarheid_2', 'leefbaarheid_3'],
      '4': ['leefbaarheid_3', 'leefbaarheid_4'],
      '5': ['leefbaarheid_3', 'leefbaarheid_4', 'leefbaarheid_5'],
    },
    economie: {
      '0': ['economie_1'],
      '1': ['economie_1', 'economie_2'],
      '2': ['economie_2', 'economie_3'],
      '3': ['economie_3', 'economie_4'],
      '4': ['economie_3', 'economie_4', 'economie_5'],
    },
    klimaat: {
      '0': ['klimaat_0'],
      '1': ['klimaat_1'],
      '2': ['klimaat_2'],
      '3': ['klimaat_3'],
      '4': ['klimaat_4'],
      '5': ['klimaat_5'],
    },
  },
};

export default sequence;
